
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-wine-glass-fill text-red-600 text-2xl"></i>
            </div>
            <h1 className="text-xl font-bold text-gray-800" style={{ fontFamily: '"Pacifico", serif' }}>
              Licores Don Juan
            </h1>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('productos')}
              className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
            >
              Productos
            </button>
            <button 
              onClick={() => scrollToSection('servicios')}
              className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
            >
              Contacto
            </button>
            <Button 
              size="sm"
              onClick={() => scrollToSection('pedidos')}
            >
              Hacer Pedido
            </Button>
          </nav>

          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-gray-700 hover:text-red-600 transition-colors text-left cursor-pointer"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('productos')}
                className="text-gray-700 hover:text-red-600 transition-colors text-left cursor-pointer"
              >
                Productos
              </button>
              <button 
                onClick={() => scrollToSection('servicios')}
                className="text-gray-700 hover:text-red-600 transition-colors text-left cursor-pointer"
              >
                Servicios
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="text-gray-700 hover:text-red-600 transition-colors text-left cursor-pointer"
              >
                Contacto
              </button>
              <Button 
                size="sm"
                onClick={() => scrollToSection('pedidos')}
                className="w-fit"
              >
                Hacer Pedido
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
